import React, { forwardRef, useEffect, useState, useMemo } from 'react'
import DropSelect from '../dropselect/render'
import FieldInfo from '../../forms/web/field-info'

// 也可自定义接口请求
const Render = function ({
  productSlugs,
  fields = [],
  required,
  data,
  errors,
  formControl,
  onChange,
}) {
  const { setValue } = formControl
  const [slugSelectsInfo, setSlugSelectsInfo] = useState([])
  const productFields = useMemo(() => {
    return productSlugs.map((v) => fields.find((f) => f.slug === v))
  }, [productSlugs, fields])

  const updateSlugSelectsInfo = (info, value, index) => {
    const arr = [...info]
    info.forEach((v, i) => {
      if (i > index) {
        setValue(productSlugs[i], null)
        arr.splice(i, 1, { ...v, value: null })
      }
      if (i === index) {
        arr.splice(i, 1, {
          ...v,
          value: value && value.length > 0 ? value[0] : null,
        })
        const obj = data.find((d) => (value || []).includes(d.objectId))
        setValue(productSlugs[i], obj && obj.title)
      }
    })
    setSlugSelectsInfo(arr)
  }

  useEffect(() => {
    const arr = productSlugs.map((v, index) => {
      return { value: null, slug: v, index }
    })
    setSlugSelectsInfo(arr)
  }, [productSlugs])

  useEffect(() => {
    const obj = slugSelectsInfo.find((v) => !v.value)
    if (!obj) {
      onChange(slugSelectsInfo.map((v) => v.value))
    } else {
      onChange(null)
    }
  }, [slugSelectsInfo, onChange])

  return (
    <>
      {productFields.map((item, index) => {
        const currentValue =
          slugSelectsInfo[index] && slugSelectsInfo[index].value

        let selects = []
        if (index === 0) {
          selects = data
            .filter((d) => d.level === index + 1)
            .map((v) => {
              return { ...v, slug: v.objectId }
            })
        } else {
          selects = data
            .filter(
              (d) =>
                d.level === index + 1 &&
                d.parentId === slugSelectsInfo[index - 1].value
            )
            .map((v) => {
              return { ...v, slug: v.objectId }
            })
        }

        const opts = {
          ...item,
          required,
          type: 'dropSelect',
          selects,
          hiddenWhenCreate: false,
        }

        return (
          <FieldInfo error={(errors && errors[item.slug]) || {}} opts={opts}>
            <div style={{ marginTop: '9px' }}>
              <DropSelect
                opts={opts}
                value={[currentValue]}
                onChange={(v) => {
                  updateSlugSelectsInfo(slugSelectsInfo, v, index)
                }}
                formControl={formControl}
              />
            </div>
          </FieldInfo>
        )
      })}
    </>
  )
}
export default forwardRef(Render)
